import { KeyRound } from "lucide-react";

const TIMES = ["Weekday mornings", "Weekday afternoons", "Weekday evenings", "Weekends", "Any time"];
const chip = (on) => `rounded-full border px-3 py-1.5 text-xs transition-colors ${on ? "border-gum bg-gum text-sand" : "border-ink/25 hover:border-ink"}`;

export const SafetyCheckIn = ({ form, setForm }) => {
  const toggle = (t) => {
    const cur = form.safe_times || [];
    setForm({ ...form, safe_times: cur.includes(t) ? cur.filter((x) => x !== t) : [...cur, t] });
  };
  return (
    <div data-testid="safety-check-in" className="mt-6 rounded-2xl border border-ink/15 bg-white/50 p-5">
      <p className="flex items-center gap-2 text-sm font-semibold"><KeyRound className="h-4 w-4 text-ochre" /> Safety check-in (optional)</p>
      <p className="mt-1 text-xs text-ink/70">Tell us when it's safe to call back. Staff will only contact you at these times.</p>
      <div className="mt-4 flex flex-wrap gap-2">
        {TIMES.map((t) => (
          <button type="button" key={t} data-testid={`safe-time-${t.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => toggle(t)} className={chip((form.safe_times || []).includes(t))}>{t}</button>
        ))}
      </div>
      <input data-testid="support-safe-input" placeholder="Other details, e.g. 'after 2pm, not when he's home' (optional)" value={form.safe_to_contact} onChange={(e) => setForm({ ...form, safe_to_contact: e.target.value })} className="field mt-3" />
      <input data-testid="support-code-word-input" maxLength={40} placeholder="Code word (optional)" value={form.code_word} onChange={(e) => setForm({ ...form, code_word: e.target.value })} className="field mt-3" />
      <p className="mt-1 text-xs text-ink/70">Staff will say this word first so you know it's really us. If you say it back, they'll know you can talk safely.</p>
      <p className="mt-4 text-xs font-semibold text-ink/80">Is it safe to leave a voicemail or message?</p>
      <div className="mt-2 flex gap-2">
        {["Yes", "No"].map((v) => (
          <button type="button" key={v} data-testid={`leave-message-${v.toLowerCase()}`} onClick={() => setForm({ ...form, ok_to_leave_message: form.ok_to_leave_message === v ? "" : v })} className={chip(form.ok_to_leave_message === v)}>{v}</button>
        ))}
      </div>
    </div>
  );
};
